import * as React from 'react'

export function PdfIcon() {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.8745 30.8504H5.50781V2.44629H18.6741L27.8745 11.436V30.8504Z"
        stroke="black"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M27.8723 11.436H18.6719V2.44629"
        stroke="black"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M10.8969 19.1416H9.52329V21.4159H8.17969V15.0908H10.9968C11.6461 15.0908 12.1655 15.2519 12.5501 15.5789C12.9347 15.9059 13.1295 16.4085 13.1295 17.0918C13.1295 17.8385 12.9347 18.3656 12.5501 18.6731C12.1655 18.9805 11.6111 19.1367 10.8969 19.1367V19.1416ZM11.5262 17.8239C11.701 17.6726 11.7909 17.4334 11.7909 17.1016C11.7909 16.7697 11.701 16.5403 11.5262 16.3988C11.3514 16.2572 11.1016 16.1889 10.782 16.1889H9.52329V18.0484H10.782C11.1016 18.0484 11.3514 17.9703 11.5262 17.819V17.8239Z"
        fill="black"
      />
      <path
        d="M16.9277 21.4159H14.1406V15.0908H16.9277C17.3273 15.0957 17.662 15.1445 17.9267 15.2275C18.3812 15.3739 18.7458 15.6423 19.0305 16.0279C19.2553 16.3402 19.4101 16.6818 19.4901 17.0479C19.57 17.4139 19.6149 17.7604 19.6149 18.0923C19.6149 18.9317 19.4401 19.6443 19.0955 20.2299C18.626 21.0157 17.9067 21.411 16.9277 21.411V21.4159ZM17.9367 16.7062C17.7269 16.3646 17.3173 16.1938 16.703 16.1938H15.4543V20.3226H16.703C17.3423 20.3226 17.7868 20.0152 18.0366 19.4002C18.1764 19.0635 18.2414 18.6633 18.2414 18.1948C18.2414 17.5506 18.1365 17.0576 17.9317 16.7111L17.9367 16.7062Z"
        fill="black"
      />
      <path
        d="M25.223 16.2133H21.9764V17.6677H24.8185V18.7658H21.9764V21.4159H20.6328V15.1006H25.218V16.2133H25.223Z"
        fill="black"
      />
    </svg>
  )
}
